import { supabase } from '@/integrations/supabase/client';
import { logger } from '@/utils/logger';

/**
 * Marque un référent comme ayant accédé au formulaire
 * Passe automatiquement le statut de "Invité" à "A répondu"
 */
export const markReferentAccessed = async (referentId: string): Promise<boolean> => {
  try {
    logger.debug('🔄 Marquage accès référent', { referentId });
    
    const { data, error } = await supabase.rpc('mark_referent_accessed', {
      referent_id_param: referentId
    });

    if (error) {
      logger.error('❌ Erreur marquage accès référent', error);
      throw error;
    }

    logger.info('✅ Référent marqué comme ayant accédé', { data });
    return data || false;
  } catch (error: unknown) {
    logger.error('💥 Erreur dans markReferentAccessed', error);
    throw new Error(`Erreur lors du marquage d'accès: ${error instanceof Error ? error.message : 'Erreur inconnue'}`);
  }
};